import { render, staticRenderFns } from "./EditerGadgetFrameV3.vue?vue&type=template&id=21ed83ea&scoped=true&"
import script from "./EditerGadgetFrameV3.vue?vue&type=script&lang=ts&"
export * from "./EditerGadgetFrameV3.vue?vue&type=script&lang=ts&"
import style0 from "./EditerGadgetFrameV3.vue?vue&type=style&index=0&id=21ed83ea&lang=scss&scoped=true&"
import style1 from "./EditerGadgetFrameV3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ed83ea",
  null
  
)

export default component.exports